import Vue from 'vue'

export default {
  // 调用微信jdk
  getWechatSign(callback){
    let axios = Vue.prototype.axios;
    let wx = Vue.prototype.wx;
    axios.get('https://sc.yunqueyi.com/wechats/signs?url='+location.href).then(res=>{
      let signMap=res.data.data.signMap;
      wx.config({
        debug: false,
        appId: 'wxcf79dbdc24cb684b',
        timestamp: signMap.timestamp,
        nonceStr: signMap.nonceStr,
        signature: signMap.signature,
        jsApiList: ['chooseWXPay','hideOptionMenu']
      });
      wx.ready(()=> {
        wx.checkJsApi({
          jsApiList: ['chooseWXPay','hideOptionMenu']
        });
        wx.hideOptionMenu();

        callback();

      });

    })
  }
}




// WEBPACK FOOTER //
// ./src/common/wechatApi.js